import { setUrlToDataSource } from './setUrlToDataSource';

export default function setMediaObjectsSources(mediaObjects, dataSourceURL) {
	return mediaObjects.map((mediaObject) => ({
		...mediaObject,
		languageContent: mediaObject.languageContent.map((content) => {
			const isImage = mediaObject.type === 'image';
			const filename = !isImage && content.mediaInfo ? `/${content.mediaInfo.filename}` : '';
			return {
				...content,
				source: setUrlToDataSource(`../media-${content.source}${filename}`, dataSourceURL),
				...(content.thumbSource && {
					thumbSource: setUrlToDataSource(`../media-${content.thumbSource}`, dataSourceURL),
				}),
			};
		}),
	}));
}
